import { createTheme } from '@mui/material';
import { ComponentThemes } from './components';

export const Theme = createTheme({
	components: ComponentThemes,
});

export default Theme;
